<template>
  <hic-dialog :title="`员工（${staff.name}）角色选择`" append-to-body :close-on-click-modal="false" :visible="visible" width="45rem" @open="open" @close="cancel">
    <el-row type="flex" justify="space-around" align="middle">
      <el-checkbox v-model="condition.onlyChecked">只显示已授权角色</el-checkbox>
    </el-row>
    <el-skeleton v-if="searchLoading" animated class="top-pad left" />
    <el-checkbox-group v-else v-model="checkList" style="height: 25rem;">
      <el-scrollbar style="height: 25rem">
        <el-row>
          <el-col :span="6" :key="item.code" v-for="item in roleList" style="padding: 1.5rem 0 0 1.5rem; text-align: left">
            <el-checkbox class="item" :label="item.code" @change="checkedChange(item.code)" :title="item.name">{{ item.name }}</el-checkbox>
          </el-col>
        </el-row>
      </el-scrollbar>
    </el-checkbox-group>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
    </div>
  </hic-dialog>
</template>
<script>
  import api from "./api.js";
  export default {
    props: {
      visible: Boolean,
      staff: Object,
    },
    data() {
      return {
        deptList: [],
        checkList: [],
        roles: { items: [] },
        condition: {
          onlyChecked: true,
          deptCode: null,
          name: null,
          pageSize: 999,
          pageIndexOnView: 1,
        },
        searchLoading: false,
      };
    },
    computed: {
      roleList() {
        if (!this.roles.items) {
          return [];
        }
        // if (!this.checkList || !this.checkList.length) {
        //   return []
        // }
        return this.roles.items.filter((item) => {
          return !this.condition.onlyChecked || this.checkList.indexOf(item.code) >= 0;
        });
      },
    },
    created() {
      this.queryRoles(1);
    },
    methods: {
      open() {
        let _this = this;
        this.searchLoading = true;
        api.Staff.queryRole(this.staff.id, {
          pageSize: 999,
          pageIndexOnView: 1,
        })
          .then((res) => {
            _this.checkList = res.items.map((item) => {
              return item.roleCode;
            });
          })
          .finally(() => {
            this.searchLoading = false;
          });
      },
      queryRoles(index) {
        if (index) {
          this.condition.pageIndexOnView = index;
        }
        let _this = this;
        api.Role.query(this.condition).then((res) => {
          _this.roles = res;
        });
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      checkedChange(code) {
        // 控件已提前修改 checkList
        if (this.checkList.indexOf(code) >= 0) {
          api.Staff.addRole(this.staff.id, code).then((res) => {
            this.$message.success("用户角色添加成功！");
            this.$utils.log("用户角色添加成功！");
          });
        } else {
          api.Staff.delRole(this.staff.id, code).then((res) => {
            this.$message.success("用户角色删除成功！");
            this.$utils.log("用户角色删除成功！");
          });
        }
      },
    },
  };
</script>
